const TYPE = "condPagto";

const condPagamentoModule = {
  findAll: async (dbConnection, limite = null) => {
    let condicoes = [];
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
      limit: limite === null ? 1000 : limite,
    });

    if (result.docs.length) {
      condicoes = result.docs;
    }

    return condicoes;
  },
  findAllByDesc: async (dbConnection, desc) => {
    desc = desc.toUpperCase();
    let condicoes = [];
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        desc: { $regex: desc },
      },
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      condicoes = result.docs;
    }

    return condicoes;
  },

  findByIdIntegracao: async (dbConnection, idIntegracao) => {
    let condicao = null;
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        idIntegracao: {$eq: idIntegracao}
      }
    });

    if (result.docs.length) {
      condicao = result.docs[0];
    }

    return condicao;
  },
};

export default condPagamentoModule;
